import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import MyStorage from './util/storage';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ViewLecture = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const model = location.state?.model || null;
  const readerRef = useRef(null);
  const [numPages, setNumPages] = useState(0);
  const [pageWidth, setPageWidth] = useState(700);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    if (!MyStorage.isLogin()) {
      navigate('/admin/login', { replace: true });
      return;
    }
    if (!model) navigate('/admin/lectures', { replace: true });
  }, [model, navigate]);

  useEffect(() => {
    const measure = () => {
      const w = readerRef.current?.clientWidth || window.innerWidth;
      setPageWidth(Math.max(320, Math.min(980, w - 48)));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && ['s', 'p'].includes(e.key.toLowerCase())) e.preventDefault();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  if (!model) return null;
  const changeZoom = (delta) => setZoom(z => Math.min(2, Math.max(.75, Number((z + delta).toFixed(2)))));

  return (
    <div className="main">
      <div className="titlebar" style={{ backgroundColor:'#f2f2f2', padding:10, margin:-15 }}>
        <div style={{ color:'blue' }}>{model.title}</div>
      </div>
      <div style={{ width:'calc(100% - 32px)', maxWidth:1400, margin:'30px auto', padding:'0 16px' }}>
        <button onClick={() => navigate('/admin/lectures')} style={{ marginBottom:12 }}>← Chapters</button>
        <div className="caridoc-pdf-controls">
          <button onClick={() => changeZoom(-.15)} disabled={zoom <= .75}>−</button>
          <span>{Math.round(zoom * 100)}%</span>
          <button onClick={() => changeZoom(.15)} disabled={zoom >= 2}>+</button>
          <button onClick={() => setZoom(1)}>Fit</button>
        </div>
        <div className="caridoc-document caridoc-pdf-reader admin-pdf-reader" ref={readerRef} onContextMenu={e => e.preventDefault()}>
          <Document
            file={model.fileUrl}
            onLoadSuccess={({ numPages:n }) => setNumPages(n)}
            loading={<div className="caridoc-pdf-status">Loading chapter…</div>}
            error={<div className="caridoc-pdf-status">Unable to display this chapter.</div>}
          >
            {Array.from({ length:numPages }, (_,i) => (
              <Page key={i+1} pageNumber={i+1} width={pageWidth * zoom} renderAnnotationLayer={false} renderTextLayer={true} />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
};

export default ViewLecture;
